/* eslint-disable no-use-before-define */
import React from 'react'
import { arrayFrom, Fields, cleanObject, fixURL, isEmpty, } from '../twd'
import Icons from './icons'
import { Formik, FieldArray, } from 'formik'


const getAccounts = () =>
    arrayFrom(global.app.config.accounts)
        .filter(a => a.positionCount>0)

export default () => {

    const formRef = React.useRef(null)

    return (
    <React.Fragment>
    <Formik
        component={Form}
        initialValues={{
            accounts: getAccounts().map(a => a.acctNo)
        }}
        validate={(values) => {
            return cleanObject({
                accounts: arrayFrom(values.accounts).length > 0
                    ? null
                    : 'Please select at least 1 account'
            })
        }}
        validateOnBlur={true}
        validateOnChange={true}
        onSubmit={(values) => {
            let frm = formRef.current
            frm.accounts.value = arrayFrom(values.accounts).filter(Boolean).join()
            frm.submit()
        }}
    />

    <form ref={formRef}
        method="POST"
        action={fixURL('https://www.bonddesk.com/etrade/servlet/rtresult/dareport.pdf').toString()}
        target="PortfolioReportWindow"
    >
        <input type="hidden" name="dbname" value="SEC" />
        <input type="hidden" name="reportname" value="CR_ANALYTICS_DEV.rpt" />
        <input type="hidden" name="format" value="5" />
        <input type="hidden" name="accounts" value="" />
        <input type="hidden" name="p1" value="Contact 1 is here" />
        <input type="hidden" name="p2" value="Contact 2 is here" />
        <input type="hidden" name="p3" value="Contact 3 is here" />
        <input type="hidden" name="p4" value="Contact 4 is here" />
        <input type="hidden" name="p5" value="Contact 5 is here" />
        <input type="hidden" name="p6" value="Contact 6 is here" />
        <input type="hidden" name="p7" value="1" />
        <input type="hidden" name="p8" value="1" />
        <input type="hidden" name="p9" value="0" />
        <input type="hidden" name="p10" value="3" />
        <input type="hidden" name="p11" value="4" />
        <input type="hidden" name="p12" value="5" />
        <input type="hidden" name="p13" value="0" />
        <input type="hidden" name="p14" value="6" />
        <input type="hidden" name="p15" value="0" />
        <input type="hidden" name="p16" value="1" />
        <input type="hidden" name="p17" value="1" />
        <input type="hidden" name="p18" value="16" />
        <input type="hidden" name="p19" value="17" />
        <input type="hidden" name="p20" value="" />
        <input type="hidden" name="p21" value="false" />
        <input type="hidden" name="p22" value="" />
        <input type="hidden" name="p23" value="false" />
        <input type="hidden" name="p24" value="0ACKMPROST" />
        <input type="hidden" name="p25" value="da_etrade_logo.jpg" />
        <input type="hidden" name="p26" value="da_etrade_logo.jpg" />
        <input type="hidden" name="p27" value="0" />
        <input type="hidden" name="p28" value="0" />
        <input type="hidden" name="p29" value="0" />
        <input type="hidden" name="p30" value="pintroduction=0_pwatermark=0" />
        <input type="hidden" name="p31" value="0"></input>
    </form>

    </React.Fragment>
    )
}

const Form = ({handleSubmit, values, errors}) => {

    const hasAccount = getAccounts().length>0

    return <React.Fragment>
    <form onSubmit={handleSubmit}>
        <div className="card card-primary purple-top">
        <div className="card-body">

        <div className="row text-center">
        {Icons.computerIcon}
        <h2>Generate a portfolio report</h2>
        </div>
        <div className="row vertical-offset-xxs">
        <div className="col-md-12">
            <fieldset>
            <FieldArray
                name="accounts"
                disabled={!hasAccount}
                render={(args) => <Fields.SelectMulti
                    dataName="portfolio-report-accounts"
                    label="Select one or more accounts to analyze"

                    emptyText=''
                    error={errors.accounts}

                    showSelectAll={hasAccount}
                    allText='All accounts selected'
                    options={ getAccounts().map(a => ({ label:a.title, value:a.acctNo, })) }
                    style={{marginBottom:'0px'}}
                    optionCheckboxLabelConfig={{
                        className:"text-truncate"
                    }}

                    placeholder={({emptyText, allText, values, options}) => {
                        let isNone = isEmpty(values)
                        if (isNone) return emptyText

                        let isAll = values.length>0 && values.length === options.length
                        if (isAll) return allText

                        let selected = options
                            .filter(a => values.indexOf(a.value)>=0)

                        let n = selected.length
                        if (n===0) return emptyText

                        return `${n} of ${options.length} accounts selected`
                    }}

                    {...args}
                />}
            />

                <label className="field-status has-error">&nbsp; {errors.accounts}</label>
            </fieldset>
        </div>
        </div>

        <div className="row vertical-offset-sm">
        <div className="col-md-12">
            <button
                type="submit"
                className="btn btn-primary btn-block"
                disabled={
                    Object.keys(errors).length>0
                    || !hasAccount
                }
            >Generate report</button>
        </div>
        </div>

        <div className="row ">
        <div className="col-md-12 text-center">
            <div style={{
                display:  'inline-flex' ,
                alignItems:'center',
                verticalAlign:'middle',
            }}>
                Reports are in PDF format
                <span style={{
                    display:'inline-flex',
                    alignItems:'center',
                    verticalAlign:'middle',
                    marginLeft:'5px',
                }}>{Icons.pdf}</span>
            </div>
        </div>
        </div>

        </div>
        </div>
    </form>
    </React.Fragment>
}


// WEBPACK FOOTER //
// ./src/portfolio-report/form.js